import * as React from 'react';
import {
    EditBase,
    Form,
    SaveButton,
    Toolbar,
    useEditContext,
} from 'react-admin';
import { Card, CardContent, Box } from '@mui/material';

import { ProjectFileConfigInputs } from './ProjectFileConfigInputs';
import { ProjectFileConfigAside } from './ProjectFileConfigAside';
import { ProjectFileConfig } from '@/types';

export const ProjectFileConfigEdit = () => (
    <EditBase mutationMode="pessimistic" redirect="show">
        <ProjectFileConfigEditContent />
    </EditBase>
);

const ProjectFileConfigEditContent = () => {
    const { isPending, record } = useEditContext<ProjectFileConfig>();
    if (isPending || !record) return null;
    return (
        <Box mt={2} display="flex">
            <ProjectFileConfigAside link="show" />
            <Box flex="1">
                <Form>
                    <Card>
                        <CardContent>
                            <ProjectFileConfigInputs />
                        </CardContent>
                        <Toolbar>
                            <SaveButton />
                        </Toolbar>
                    </Card>
                </Form>
            </Box>
        </Box>
    );
};
